<template>
    <page>
        <module :title="verify ? '特殊价格申请审核' : '特殊价格申请详情'">
            <div>
                <c-detail title="基础信息">
                    <c-detail-item label="申请单号" >
                        {{detailData.apply_number}}
                    </c-detail-item>
                    <c-detail-item label="审批状态" >
                        <span v-if="detailData.state == 0" style="color:#999"> 草稿</span>
                        <span v-if="detailData.state == 1" style="color:blue">待审核</span>
                        <span v-if="detailData.state == 2" style="color:green"> 审核通过</span>
                        <span v-if="detailData.state == -1" style="color:red">审核驳回</span>
                    </c-detail-item>
                    <c-detail-item label="启用状态" >
                        <span v-if="detailData.state == 2">
                           <span v-if="detailData.enable_state == 0" style="color:red">禁用</span>
                           <span v-if="detailData.enable_state == 1" style="color:green">启用</span>
                        </span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item  v-if="detailData.state ==1 || detailData.state ==2 || detailData.state =='-1' " label="申请时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <c-detail-item  v-if="detailData.state ==1 || detailData.state ==2 || detailData.state =='-1' " label="申请人姓名">
                        {{detailData.apply_name}}
                    </c-detail-item>
                    <c-detail-item label="管控类型" full>
                         <span v-if="detailData.type == 1" style="color:blue">按商品</span>
                         <span v-if="detailData.type == 2" style="color:green">按品牌</span>
                    </c-detail-item>
                    <c-detail-item v-if="detailData.state == 2 || detailData.state == '-1'" label="审批时间">
                        {{detailData.audit_date}}
                    </c-detail-item>
                    <c-detail-item v-if="detailData.state == 2 || detailData.state == '-1'" label="审批人姓名">
                        {{detailData.approval_name}}
                    </c-detail-item>
                    <c-detail-item  v-if="detailData.state =='-1' " label="驳回原因" full>
                        <span style="color: red">
                           {{detailData.rejected_reason}}
                        </span>
                    </c-detail-item>
                </c-detail>
                <c-detail title="会员信息">
                    <c-detail-item label="目标用户" full>
                        <c-table v-model="memberList" height="auto" border>
                            <c-table-column
                                label="会员手机号"
                                name="user_manage_mobilephone"
                                width="120"
                            ></c-table-column>

                            <c-table-column
                                label="会员头像/昵称"
                                name="head_photo"
                                width="120"
                            >
                                <template v-slot="{data}">
                                    <div class="flex-center-cross">
                                        <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                                        <span>{{data.nick_name||'--'}}</span>
                                    </div>
                                </template>
                            </c-table-column>

                            <c-table-column
                                label="用户名"
                                name="login_name"
                                width="60"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.login_name && data.login_name!=''">{{data.login_name}}</span>
                                    <span v-else>--</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="生效时间"
                                    name="begin_time"
                            ></c-table-column>

                            <c-table-column
                                    label="截止时间"
                                    name="end_time"
                            ></c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
                <c-detail title="商品信息" v-show="type == 1" >
                    <c-detail-item label="指定品牌" full>
                      <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                        <c-table-column
                            label="商品信息"
                            name="product_name"
                            width="200"
                        >
                          <template v-slot="{data}">
                            <div class="flex-center">
                              <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                              <p v-if="data.product_itemnumber">【{{data.product_itemnumber}}】</p>
                              <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                            </div>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="价格"
                            name="product_price"
                            width="140"
                        >
                          <template v-slot="{data}">
                            ￥{{data.product_price_min}}
                            <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="优惠方式"
                            width="120"
                        >
                          <template v-slot="{data}">
                              {{preferentialTypeName[data.preferential_type]}}
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="折扣"
                            width="100"
                        >
                          <template v-slot="{data}">
                              <span v-if="data.preferential_type==1">{{data.discount}} 折</span>
                              <span v-else>--</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="减免金额"
                            width="100"
                        >
                          <template v-slot="{data}">
                              <span v-if="data.preferential_type==2">{{data.reduced_money}} 元</span>
                              <span v-else>--</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="促销价"
                            name="promotion_price"
                            width="140"
                        >
                          <template v-slot="{data}">
                              <span v-if="data.preferential_type==1 && data.discount" >
                                        ￥{{parseFloat(data.product_price_min * data.discount / 10).toFixed(2)}}
                                        <span v-if="data.product_price_max">
                                            - ￥{{parseFloat(data.product_price_max * data.discount / 10).toFixed(2)}}
                                        </span>
                              </span>
                            <span v-if="data.preferential_type==2 && data.reduced_money" >
                                        ￥{{parseFloat(data.product_price_min - data.reduced_money).toFixed(2)}}
                                        <span v-if="data.product_price_max">
                                            - ￥{{parseFloat(data.product_price_max - data.reduced_money).toFixed(2)}}
                                        </span>
                              </span>
                          </template>
                        </c-table-column>
                      </c-table>
                    </c-detail-item>
                </c-detail>
                <c-detail title="品牌信息" v-show="type == 2" >
                    <c-detail-item label="指定品牌" full>
                        <c-table v-model="brandList" height="auto" border>
                          <c-table-column
                              label="品牌"
                              name="brand_name"
                              width="120"
                          >
                            <template v-slot="{data}">
                              <div class="flex-center">
                                <c-image v-if="data.logo" :src="data.logo" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.brand_name}}</p>
                              </div>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="优惠方式"
                              width="120"
                          >
                            <template v-slot="{data}">
                              {{preferentialTypeName[data.preferential_type]}}
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="折扣"
                              width="100"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.preferential_type==1">{{data.discount}} 折</span>
                              <span v-else>--</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="减免金额"
                              width="100"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.preferential_type==2">{{data.reduced_money}} 元</span>
                              <span v-else>--</span>
                            </template>
                          </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>

            <template v-if="verify" slot="button">
                <c-button size="m" @click="verifyHandle(2)">审核通过</c-button>
                <c-button size="m" color="red" @click="verifyHandle(-1)">审核驳回</c-button>
            </template>
        </module>

        <c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="approvalHandle">
            <div class="approval-eason">
                <textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
            </div>
        </c-dialog>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'special_price_detail',

        props: {
            id: String,
            verify: Boolean
        },

        data() {
            return {
                detailData: {},
                memberList: [],
                approvalReason: '',
                brandList: [],
                productList: [],
                type: 1,/**类型 2：品牌 1：商品**/
                preferentialTypeName: {
                    1: '基础价格打折',
                    2: '减免固定金额'
                }
            }
        },

        computed: {
            ...mapState(['dict']),
            stateName() {
                return {
                    0: '草稿',
                    1: '待审核',
                    2: '审批通过',
                    '-1': '驳回'
                }[this.detailData.state];
            },
        },

        watch: {
            id() {
                this.getTaskDetail();
            }
        },

        mounted() {
            this.getTaskDetail();
        },

        methods: {
            getTaskDetail() {
                this.request({
                    url: '/special_price/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.detailData = data;
                        this.memberList = data.user_list || [];
                        this.brandList = data.brand_list || [];
                        this.productList = data.product_list || [];
                        this.type = data.type || 1;
                    }
                });
            },
            verifyHandle(state) {
                if(state == '-1'){
                    this.$refs.approvalReason.open();
                }else{
                    this.$confirm({
                        text: '确定要审批通过吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/special_price/apply',
                                data: {
                                    id: this.id,
                                    state
                                },
                                loading: true,
                                success: () => {
                                    this.$message({
                                        text: '审核成功'
                                    });
                                    this.$bus.$emit('specialPriceList.update');
                                    this.redirectTo('/special_price_list');
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
                }


            },
            approvalHandle(stop){
                if (!this.approvalReason.trim()) {
                    this.$message({
                        text: '请填写驳回原因'
                    });
                    stop();
                    return;
                }
                this.request({
                    url: '/special_price/apply',
                    data: {id:this.id,state:'-1',rejected_reason:this.approvalReason.trim()},
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '驳回成功',
                            icon: 'success'
                        });
                        this.$bus.$emit('specialPriceList.update');
                        this.redirectTo('/special_price_list');
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .approval-eason {
    padding: 20px;

    textarea {
      box-sizing: border-box;
      width: 100%;
      height: 120px;
      border: none;
      padding: 10px 14px;
      line-height: 20px;
      background: #FAFAFA;
      resize: none;
    }
  }
</style>